/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_DealInputs */

const en_directory_promotion_benefits_deal = /** @type {(inputs: Directory_Promotion_Benefits_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal callout`)
};

const zh_directory_promotion_benefits_deal = /** @type {(inputs: Directory_Promotion_Benefits_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优惠提示`)
};

/**
* | output |
* | --- |
* | "Deal callout" |
*
* @param {Directory_Promotion_Benefits_DealInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_deal = /** @type {((inputs?: Directory_Promotion_Benefits_DealInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_DealInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_deal(inputs)
	return zh_directory_promotion_benefits_deal(inputs)
});
export { directory_promotion_benefits_deal as "directory.promotion.benefits.deal" }